import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box,
  Button,
  Card,
  CardBody,

  Checkbox,
  FormControl,
  FormLabel,
  Grid,
  Heading,
  Input,
  Select,
  Textarea,
  Text,
  VStack,
  HStack,
  Flex,
  IconButton,

  Alert,
  AlertIcon,
  AlertDescription,

  useToast,
  Tag,
} from '@chakra-ui/react';
import ReactSelect from "react-select";

import { ChannelTabsFixed } from './ChannelTabsFixed';
import Header from '../../../components/Header';
import { fetchWrapper } from '../../../helpers';

import { useNavigate, useParams } from 'react-router-dom';
import {
  LuBell, LuMail, LuMessageCircle, LuMessageSquare, LuPhone,
  LuSave, LuDollarSign, LuActivity, LuTarget, LuPlus, LuTrash2, LuGlobe, LuMonitor, LuZap,
} from 'react-icons/lu';
import BoxWrapper from '../../../components/BoxWrapper/BoxWrapper';
import { COUNTRY_CODES, languageOptions } from '../../../utils/DefaultFunction';




const countryCodes = [
  { code: '+1', country: 'US', flag: '🇺🇸', name: 'United States' },
  { code: '+44', country: 'GB', flag: '🇬🇧', name: 'United Kingdom' },
  { code: '+91', country: 'IN', flag: '🇮🇳', name: 'India' },
  { code: '+92', country: 'PK', flag: '🇵🇰', name: 'Pakistan' },
  { code: '+971', country: 'AE', flag: '🇦🇪', name: 'UAE' },
  { code: '+966', country: 'SA', flag: '🇸🇦', name: 'Saudi Arabia' },
  { code: '+49', country: 'DE', flag: '🇩🇪', name: 'Germany' },
  { code: '+33', country: 'FR', flag: '🇫🇷', name: 'France' },
  { code: '+39', country: 'IT', flag: '🇮🇹', name: 'Italy' },
  { code: '+34', country: 'ES', flag: '🇪🇸', name: 'Spain' }
];



// const messageExpiryOptions = [

//   { value: 30000, label: '30 seconds', duration: "Expired in 30 seconds" },
//   { value: 60000, label: '1 minute', duration: "Expired in 1 minute" },
//   { value: 120000, label: '2 minutes', duration: "Expired in 2 minutes" },
//   { value: 180000, label: '3 minutes', duration: "Expired in 3 minutes" },
//   { value: 300000, label: '5 minutes', duration: "Expired in 5 minutes" },
//   { value: 600000, label: '10 minutes', duration: "Expired in 10 minutes" },
//   { value: 900000, label: '15 minutes', duration: "Expired in 15 minutes" }
// ];

// const languageOptions = [
//   { value: "en_US", label: 'English US' },
//   { value: "en", label: 'English' },
// ];

export default function TemplateManager({ isEdit }) {
  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [templateName, setTemplateName] = useState('');
  const [templateType, setTemplateType] = useState('1');
  const [description, setDescription] = useState('');
  const [selectedChannels, setSelectedChannels] = useState([]);

  const [variables, setVariables] = useState([]);
  const [variableSampleValues, setVariableSampleValues] = useState({});

  const [whatsappBody, setWhatsappBody] = useState("");
  const [whatsappHeader, setWhatsappHeader] = useState({ type: null, content: '' });
  const [whatsappFooter, setWhatsappFooter] = useState('');
  const [whatsappButtons, setWhatsappButtons] = useState([]);
  const [whatsappMessageExpiry, setWhatsappMessageExpiry] = useState(60000);
  const [whatsappMessageExpiryEnabled, setWhatsappMessageExpiryEnabled] = useState(false);

  const [otpType, setOtpType] = useState("COPY_CODE");
  const [otpApps, setOtpApps] = useState([{ package_name: '', signature_hash: '' }]);

  const [inAppBody, setInAppBody] = useState('');
  const [inAppHeader, setInAppHeader] = useState({ type: null, content: '' });
  const [inAppFooter, setInAppFooter] = useState('');
  const [inAppButtons, setInAppButtons] = useState([]);
  const [inAppMessageExpiry, setInAppMessageExpiry] = useState('');
  const [inAppMessageExpiryEnabled, setInAppMessageExpiryEnabled] = useState(false);

  const [smsBody, setSmsBody] = useState('');
  const [pushTitle, setPushTitle] = useState('');
  const [pushBody, setPushBody] = useState('');
  const [pushImage, setPushImage] = useState('');
  const [deeplink, setPushDeepLink] = useState('');

  const [emailSubject, setEmailSubject] = useState('');
  const [emailType, setEmailType] = useState('text');
  const [emailHtml, setEmailHtml] = useState('');
  const [emailTemplate, setEmailTemplate] = useState('');
  const [authCodeExpiryMinutes, setAuthCodeExpiryMinutes] = useState('1');

  const [uploading, setUploading] = useState(false);
  const [authAddSecurityRecommendation, setAuthAddSecurityRecommendation] = useState(true);
  const [authAddExpirationTime, setAuthAddExpirationTime] = useState(false);

  const [voiceScript, setVoiceScript] = useState('');
  const [voiceRetries, setVoiceRetries] = useState('');
  const [voiceCallType, setVoiceCallType] = useState('text_to_voice'); // 'text_to_voice' | 'recorded_call'
  const [voiceCallId, setVoiceCallId] = useState('');
  const [voiceVariableSource, setVoiceVariableSource] = useState('from_channels'); // 'from_channels' | 'custom'
  const [ivrVariables, setIvrVariables] = useState([]);
  const [templateTypes, setMessageTemplateTypeList] = useState([]);
  const [lang, setLang] = useState("en");

  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const { id } = useParams()
  const toast = useToast()
  const [whatsappStatusId, setWhatsappStatusid] = useState("")
  const ALL_CHANNELS = [
    { name: "Whatsapp", id: 2, icon: LuMessageCircle, color: "#00a63e" },
    { name: "SMS", id: 1, icon: LuMessageSquare, color: "#155dfc" },
    { name: "Push Notification", id: 6, icon: LuBell, color: "#f54a00" },
    { name: "In-App Notification", id: 5, icon: LuBell, color: "#0092b8" },
    { name: "Voice (IVR)", id: 4, icon: LuPhone, color: "#9810fa" },
    { name: "E-Mail", id: 3, icon: LuMail, color: "#e7000b" },
  ];
  const [tabIndex, setTabIndex] = React.useState(0);
  const navigate = useNavigate()
  // 3. Add these state variables (add with your other useState declarations)
  const [customerList, setCustomerList] = useState([]);
  const [availableChannels, setAvailableChannels] = useState([]);
  const [currentCustomer, setCurrentCustomer] = useState(null);
  const [templateDataGlobal, settemplateData] = useState(null);




  // 4. Add this useEffect to load customer from localStorage (add after your existing useEffects)
  useEffect(() => {
    const customerData = localStorage.getItem("customer_id");
    if (customerData) {
      try {
        // const customer = JSON.parse(customerData);
        const customerId = selectedCustomer

        if (customerId) {

          setCurrentCustomer(customerId);
          setSelectedCustomer(customerId);
        }
      } catch (error) {
        console.error('Error parsing customer data:', error);
        toast({
          title: 'Error',
          description: 'Failed to load customer data',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    }

    // Load customers list
    LoadCustomers();
  }, []);


  // 5. Add LoadCustomers function (add after LoadMessageTemplateType)
  const LoadCustomers = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/customer/list`;
      const data = await fetchWrapper.get(url);
      setCustomerList(data.data || []);

    } catch (error) {
      console.error('Error loading customers:', error);
      toast({
        title: 'Error',
        description: 'Failed to load customers',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // 6. Add helper function to get customer's available channels
  const getCustomerChannels = (customerId, customers = customerList) => {
    if (!customerId || !customers.length) {

      return [];
    }

    const customer = customers.find(c => c.id === Number(customerId));

    console.log(customer, customers, Number(customerId))
    if (!customer || !customer.customer_channel) {

      return [];
    }

    const channelIds = customer.customer_channel.map(id => Number(id));
    const customerChannels = ALL_CHANNELS.filter(channel =>
      channelIds.includes(channel.id)
    );


    return customerChannels;
  };

  // 7. Add useEffect to update available channels when customer loads
  useEffect(() => {
    if (currentCustomer && customerList.length > 0) {
      const customerChannels = getCustomerChannels(currentCustomer, customerList);
      setAvailableChannels(customerChannels);


      if (isEdit && selectedChannels.length > 0) {
        filterSelectedChannelsByAvailability(customerChannels);
      }
    }
  }, [currentCustomer, customerList]);

  // 8. Add function to filter selected channels by availability
  const filterSelectedChannelsByAvailability = (customerChannels) => {
    const availableChannelNames = customerChannels.map(ch => ch.name);

    const filteredSelectedChannels = selectedChannels.filter(
      channelName => availableChannelNames.includes(channelName)
    );

    if (filteredSelectedChannels.length !== selectedChannels.length) {


      setSelectedChannels(filteredSelectedChannels);

      const removedCount = selectedChannels.length - filteredSelectedChannels.length;
      toast({
        title: 'Channels Updated',
        description: `${removedCount} channel(s) removed as they are not available for this customer`,
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
    }
  };




  useEffect(() => {
    if (isEdit && id) {
      loadTemplateForEdit();
    }
  }, [isEdit, id]);

  const loadTemplateForEdit = async () => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_URL}/template-message/get-by-id?id=${id}`;
      const response = await fetchWrapper.get(url);

      if (response.data) {
        const templateData = response.data;

        settemplateData(templateData)
        if (templateData.message_combine) {
          try {
            const parsedData = JSON.parse(templateData.message_combine);
            setWhatsappStatusid(templateData?.whatsapp_status_id)
            setTemplateName(parsedData.templateName || '');
            setLang(parsedData.lang || '');
            setTemplateType(parsedData.templateType || '');
            setDescription(parsedData.description || '');
            setSelectedCustomer(parsedData.customer_id || '');
            setCurrentCustomer(parsedData.customer_id || '');
            setAuthAddExpirationTime(parsedData.authCodeExpiryMinutes || '');

            // Set channels
            setSelectedChannels(parsedData.selectedChannels || []);

            // Set variables
            if (parsedData.variables && Array.isArray(parsedData.variables)) {
              setVariables(parsedData.variables);

              // Set variable sample values
              const sampleValues = {};
              parsedData.variables.forEach(v => {
                sampleValues[v.name] = v.description;
              });
              setVariableSampleValues(sampleValues);
            }

            if (parsedData.whatsappBody) {
              setWhatsappBody(parsedData.whatsappBody);
            }
            if (parsedData.whatsappHeader) {
              setWhatsappHeader({
                type: parsedData.whatsappHeader.type,
                content: parsedData.whatsappHeader.content || parsedData.whatsappHeader.headerText || '',
                file: parsedData.whatsappHeader.fileUrl || '',
                document_filename: parsedData.whatsappHeader.document_filename || '',
                footerText: parsedData.whatsappHeader.footerText,
                latitude: parsedData.whatsappHeader.latitude,
                location_address: parsedData.whatsappHeader.location_address,
                location_name: parsedData.whatsappHeader.location_name,
                longitude: parsedData.whatsappHeader.longitude,
              });
            }
            if (parsedData.whatsappFooter) {
              setWhatsappFooter(parsedData.whatsappFooter);
            }
            if (parsedData.deep_link) {
              setPushDeepLink(parsedData.deep_link);
            }
            if (parsedData.whatsappButtons && Array.isArray(parsedData.whatsappButtons)) {
              setWhatsappButtons(parsedData.whatsappButtons);
            }
            if (parsedData.isExpiryEnabled !== undefined) {
              setWhatsappMessageExpiryEnabled(parsedData.isExpiryEnabled);
            }
            if (parsedData.expiry_time !== undefined) {
              setWhatsappMessageExpiry(parsedData.expiry_time.toString());
            }

            // Set In-App data
            if (parsedData.inAppBody) {
              setInAppBody(parsedData.inAppBody);
            }
            if (parsedData.inAppHeader) {
              setInAppHeader({
                type: parsedData.inAppHeader.type || 'text',
                content: parsedData.inAppHeader.content || parsedData.inAppHeader.headerText || '',
                file: parsedData.inAppHeader.fileUrl || ''
              });
            }
            if (parsedData.inAppFooter) {
              setInAppFooter(parsedData.inAppFooter);
            }
            if (parsedData.inAppButtons && Array.isArray(parsedData.inAppButtons)) {
              setInAppButtons(parsedData.inAppButtons);
            }
            if (parsedData.inAppMessageExpiry !== undefined) {
              setInAppMessageExpiry(parsedData.inAppMessageExpiry.toString());
              setInAppMessageExpiryEnabled(parsedData.inAppMessageExpiry > 0);
            }

            // Set SMS data
            if (parsedData.smsBody) {
              setSmsBody(parsedData.smsBody);
            }

            // Set Push data
            if (parsedData.pushTitle) {
              setPushTitle(parsedData.pushTitle);
            }
            if (parsedData.pushBody) {
              setPushBody(parsedData.pushBody);
            }
            if (parsedData.pushImage) {

              // Handle both string and object formats
              if (typeof parsedData.pushImage === 'string') {
                setPushImage(parsedData.pushImage);
              } else if (parsedData.pushImage.url) {
                setPushImage(parsedData.pushImage.url);
              }
            }

            // Set Email data
            if (parsedData.emailSubject) {
              setEmailSubject(parsedData.emailSubject);
            }
            if (parsedData.emailType) {
              setEmailType(parsedData.emailType);
            }
            if (parsedData.emailHtml) {
              setEmailHtml(parsedData.emailHtml);
            }
            if (parsedData.emailTemplate) {
              setEmailTemplate(parsedData.emailTemplate);
            }

            // Set Voice data
            if (parsedData.voiceScript) {
              setVoiceScript(parsedData.voiceScript);
            }
            if (parsedData.voiceRetries) {
              setVoiceRetries(parsedData.voiceRetries);
            }
            if (parsedData.voiceCallType) {
              setVoiceCallType(parsedData.voiceCallType);
            }
            if (parsedData.voiceCallId) {
              setVoiceCallId(parsedData.voiceCallId);
            }
            if (parsedData.voiceVariableSource) {
              setVoiceVariableSource(parsedData.voiceVariableSource);
            }
            if (parsedData.ivr_variables && Array.isArray(parsedData.ivr_variables)) {
              setIvrVariables(parsedData.ivr_variables);
            }

            // Set OTP data if template type is OTP
            if (parsedData.otpType) {
              setOtpType(parsedData.otpType);
            }
            if (parsedData.otpApps && Array.isArray(parsedData.otpApps)) {
              setOtpApps(parsedData.otpApps);
            }
            if (parsedData.authAddSecurityRecommendation !== undefined) {
              setAuthAddSecurityRecommendation(parsedData.authAddSecurityRecommendation);
            }
            if (parsedData.authAddExpirationTime !== undefined) {
              setAuthAddExpirationTime(parsedData.authAddExpirationTime);
            }

            // Set Events - Convert from API format to component format
            if (parsedData.events && Array.isArray(parsedData.events)) {
              const eventsForComponent = parsedData.events.map((eventObj, index) => {
                // Check if it's already in component format or API format
                if (eventObj.eventName !== undefined) {
                  // Already in component format
                  return eventObj;
                } else {
                  // API format - convert to component format
                  const eventName = Object.keys(eventObj)[0];
                  const eventData = eventObj[eventName];

                  return {
                    id: `event_${Date.now()}_${index}`,
                    eventName: eventName,
                    fixedValue: eventData.fixed_value || '',
                    dynamicValue: eventData.dynamic_value || []
                  };
                }
              });

              setEvents(eventsForComponent);
            }

            toast({
              title: "Template Loaded",
              description: "Template data loaded successfully",
              status: "success",
              duration: 2000,
              isClosable: true,
            });

          } catch (parseError) {
            console.error('Error parsing message_combine:', parseError);
            toast({
              title: "Parse Error",
              description: "Failed to parse template data",
              status: "error",
              duration: 5000,
              isClosable: true,
            });
          }
        }
      }
    } catch (error) {
      console.error('Error loading template data:', error);
      toast({
        title: "Load Error",
        description: error.response?.data?.message || "Failed to load template data",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };





  useEffect(() => {
    if (!isEdit) {

      if (templateType === "1" && selectedChannels.includes('Whatsapp')) {
        setWhatsappBody('$otp is your verification code.');

        if (authAddSecurityRecommendation) {
          setWhatsappBody('$otp is your verification code. For your security, do not share this code.');
        }
      } else {
        setWhatsappBody("")
      }
    }



    // if (templateType === '1' && (authAddSecurityRecommendation && selectedChannels.includes('Whatsapp'))) {

    //   setWhatsappBody('$otp is your verification code. For your security, do not share this code.');
    // } else if (templateType === '1' && (authAddSecurityRecommendation === false && selectedChannels.includes('Whatsapp'))) {
    //   setWhatsappBody('$otp is your verification code.');
    // } else {
    //   if (isEdit) {
    //     setWhatsappBody(whatsappBody);
    //   } else if (selectedChannels.includes('Whatsapp')) {
    //     setWhatsappBody("")
    //   }
    // }
  }, [templateType, authAddSecurityRecommendation]);


  useEffect(() => {
    if (!isEdit) {
      setWhatsappBody('$otp is your verification code. For your security, do not share this code.');
    }

    LoadMessageTemplateType();

  }, []);

  const LoadMessageTemplateType = async () => {

    try {
      const url = `${process.env.REACT_APP_API_URL}/message-type/list`;
      const data = await fetchWrapper.get(url);
      setMessageTemplateTypeList(data.data || []);
    } catch (error) {
      console.error('Error loading template types:', error);

    }
  };

  useEffect(() => {
    const channelVars = extractAllChannelVariables();


    const newVariables = channelVars.map(varName => {
      // const existing = variables.find(v => v.name === varName);

      return { name: varName, description: variableSampleValues[varName] };
    });

    const hasChanged =
      newVariables.length !== variables.length ||
      newVariables.some(nv => !variables.find(v => v.name === nv.name));

    if (hasChanged) {
      setVariables(newVariables);
    }
  }, [whatsappBody, inAppBody, smsBody, pushTitle, pushBody, emailSubject, emailHtml, voiceScript]);

  const extractVariablesFromContent = (content) => {
    const matches = content.match(/\$[a-zA-Z_][a-zA-Z0-9_]*/g);
    if (!matches) return [];
    return [...new Set(matches.map(match => match.slice(1)))];
  };

  const extractAllChannelVariables = () => {
    const allVariables = new Set();

    if (whatsappBody) extractVariablesFromContent(whatsappBody).forEach(v => allVariables.add(v));
    if (inAppBody) extractVariablesFromContent(inAppBody).forEach(v => allVariables.add(v));
    if (smsBody) extractVariablesFromContent(smsBody).forEach(v => allVariables.add(v));
    if (pushBody) extractVariablesFromContent(pushBody).forEach(v => allVariables.add(v));
    if (pushTitle) extractVariablesFromContent(pushTitle).forEach(v => allVariables.add(v));
    if (voiceScript) extractVariablesFromContent(voiceScript).forEach(v => allVariables.add(v));
    if (emailHtml) extractVariablesFromContent(emailHtml).forEach(v => allVariables.add(v));
    if (emailSubject) extractVariablesFromContent(emailSubject).forEach(v => allVariables.add(v));

    return Array.from(allVariables);
  };

  const getVariableChannelUsage = (variableName) => {
    const usage = [];

    if (selectedChannels.includes('WhatsApp')) {
      usage.push({ channel: 'WhatsApp', present: whatsappBody.includes(`$${variableName}`) });
    }
    if (selectedChannels.includes('In-App')) {
      usage.push({ channel: 'In-App', present: inAppBody.includes(`$${variableName}`) });
    }
    if (selectedChannels.includes('SMS')) {
      usage.push({ channel: 'SMS', present: smsBody.includes(`$${variableName}`) });
    }
    if (selectedChannels.includes('Push')) {
      usage.push({ channel: 'Push', present: pushBody.includes(`$${variableName}`) || pushTitle.includes(`$${variableName}`) });
    }
    if (selectedChannels.includes('Voice')) {
      usage.push({ channel: 'Voice', present: voiceScript.includes(`$${variableName}`) });
    }
    if (selectedChannels.includes('Email')) {
      usage.push({ channel: 'Email', present: emailHtml.includes(`$${variableName}`) || emailSubject.includes(`$${variableName}`) });
    }

    return usage;
  };

  const getVariableChannelUsageForConsistency = (variableName) => {
    const usage = [];

    if (selectedChannels.includes('WhatsApp')) {
      usage.push({ channel: 'WhatsApp', present: whatsappBody.includes(`$${variableName}`) });
    }
    if (selectedChannels.includes('In-App')) {
      usage.push({ channel: 'In-App', present: inAppBody.includes(`$${variableName}`) });
    }
    if (selectedChannels.includes('SMS')) {
      usage.push({ channel: 'SMS', present: smsBody.includes(`$${variableName}`) });
    }
    if (selectedChannels.includes('Push')) {
      const pushHasVariables = /\$[a-zA-Z_][a-zA-Z0-9_]*/.test(pushTitle) || /\$[a-zA-Z_][a-zA-Z0-9_]*/.test(pushBody);
      if (pushHasVariables) {
        usage.push({ channel: 'Push (Title)', present: pushTitle.includes(`$${variableName}`) });
      }
    }
    if (selectedChannels.includes('Voice')) {
      usage.push({ channel: 'Voice', present: voiceScript.includes(`$${variableName}`) });
    }
    if (selectedChannels.includes('Email')) {
      usage.push({ channel: 'Email', present: emailHtml.includes(`$${variableName}`) || emailSubject.includes(`$${variableName}`) });
    }

    return usage;
  };

  const allChannelVariables = extractAllChannelVariables();
  const hasInconsistentVariables = allChannelVariables.some(varName => {
    const usage = getVariableChannelUsageForConsistency(varName);
    return usage.length > 0 && usage.some(u => !u.present);
  });

  const updateVariableSampleValue = (varName, sampleValue) => {
    setVariableSampleValues(prev => ({ ...prev, [varName]: sampleValue }));
    setVariables(prev => prev.map(v =>
      v.name === varName ? { ...v, description: sampleValue } : v
    ));
  };

  const handleChannelToggle = (channelId) => {


    setSelectedChannels(prev => {
      const isCurrentlySelected = prev.includes(channelId);

      if (isCurrentlySelected) {
        // If unchecking, remove this channel
        return prev.filter(id => id !== channelId);
      } else {
        // If checking, add both in-app and push
        const newChannels = [...prev, channelId];

        // Auto-select the other channel
        if (channelId === 'In-App Notification' && !prev.includes('Push Notification')) {
          newChannels.push('Push Notification');
        } else if (channelId === 'Push Notification' && !prev.includes('In-App Notification')) {
          newChannels.push('In-App Notification');
        }

        return newChannels;
      }
    });
  };

  const handleWhatsAppHeaderTypeChange = (type) => {
    setWhatsappHeader({ type, content: '', file: '' });
  };

  const handleInAppHeaderTypeChange = (type) => {
    setInAppHeader({ type, content: '', file: '' });
  };

  const uploadFile = async (file) => {
    setUploading(true);
    const formDataUpload = new FormData();
    formDataUpload.append("file", file);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/template-message/media-upload`,
        formDataUpload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-access-token": localStorage.getItem("user"),
          },
        }
      );

      const result = response.data;

      if (result.success) {
        toast({
          title: "Success",
          description: result.message,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        return result.fileUrl;
      } else {
        throw new Error(result.message || "Upload failed");
      }
    } catch (error) {
      toast({
        title: "Upload Error",
        description: error.response?.data?.message || error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
      return null;
    } finally {
      setUploading(false);
    }
  };

  const handleFileUpload = async (event, target) => {
    const file = event.target.files?.[0];
    if (file) {
      const fileUrl = await uploadFile(file);
      if (fileUrl) {
        if (target === 'whatsapp-header') {
          setWhatsappHeader(prev => ({ ...prev, file: fileUrl }));
        } else if (target === 'inapp-header') {
          setInAppHeader(prev => ({ ...prev, file: fileUrl }));
        } else if (target === 'push-image') {
          setPushImage(fileUrl);
        }
      }
    }
  };

  const removeImage = (target) => {
    if (target === 'whatsapp-header') {
      setWhatsappHeader(prev => ({ ...prev, file: '' }));
    } else if (target === 'inapp-header') {
      setInAppHeader(prev => ({ ...prev, file: '' }));
    } else if (target === 'push-image') {
      setPushImage('');
    }
  };

  const addWhatsAppButton = () => {
    if (whatsappButtons.length < 3) {
      const newButton = {
        id: `btn_${Date.now()}`,
        type: 'custom-link',
        name: '',
        countryCode: '+1',
        urlType: 'static'
      };
      setWhatsappButtons([...whatsappButtons, newButton]);
    }
  };

  const updateWhatsAppButton = (id, updates) => {
    setWhatsappButtons(prev => prev.map(btn =>
      btn.id === id ? { ...btn, ...updates } : btn
    ));
  };

  const removeWhatsAppButton = (id) => {
    setWhatsappButtons(prev => prev.filter(btn => btn.id !== id));
  };

  const addInAppButton = () => {
    if (inAppButtons.length < 3) {
      const newButton = {
        id: `btn_${Date.now()}`,
        type: 'custom-link',
        name: '',
        countryCode: '+1',
        urlType: 'static'
      };
      setInAppButtons([...inAppButtons, newButton]);
    }
  };

  const updateInAppButton = (id, updates) => {
    setInAppButtons(prev => prev.map(btn =>
      btn.id === id ? { ...btn, ...updates } : btn
    ));
  };

  const removeInAppButton = (id) => {
    setInAppButtons(prev => prev.filter(btn => btn.id !== id));
  };

  // Add this helper function near the top of your component
  const getTabIndexForChannel = (channelName) => {
    return availableChannels.findIndex(ch => ch.name === channelName);
  };
  const syncWhatsAppToInApp = () => {
    setInAppHeader(whatsappHeader);
    setInAppFooter(whatsappFooter);
    setInAppBody(whatsappBody)
    setInAppButtons([...whatsappButtons]);
    setTabIndex(3)
    toast({
      title: "Success",
      description: "All Settings are sync to Inapp",
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  const syncInAppToWhatsApp = () => {
    setWhatsappHeader(inAppHeader);
    setWhatsappFooter(inAppFooter);
    setWhatsappBody(inAppBody)
    setWhatsappButtons([...inAppButtons]);
    setTabIndex(0)
    toast({
      title: "Success",
      description: "All Settings are sync to Whatsapp",
      status: "success",
      duration: 3000,
      isClosable: true,
    });
  };

  const addOtpApp = () => {
    if (otpApps.length < 5) {
      setOtpApps([...otpApps, { package_name: '', signature_hash: '' }]);
    }
  };

  const updateOtpApp = (index, field, value) => {
    const updated = [...otpApps];
    updated[index][field] = value;
    setOtpApps(updated);
  };

  const removeOtpApp = (index) => {
    if (otpApps.length > 1) {
      setOtpApps(otpApps.filter((_, i) => i !== index));
    }
  };

  const addEvent = () => {
    const newEvent = {
      id: `event_${Date.now()}`,
      eventName: '',
      dynamicValue: [],
      fixedValue: ''
    };
    setEvents([...events, newEvent]);
  };

  const updateEvent = (id, updates) => {
    setEvents(prev => prev.map(event =>
      event.id === id ? { ...event, ...updates } : event
    ));
  };

  const removeEvent = (id) => {
    setEvents(prev => prev.filter(event => event.id !== id));
  };

  const updateEventDynamicValue = (eventId, variableName, isSelected) => {
    setEvents(prev => prev.map(event => {
      if (event.id === eventId) {
        const currentValues = event.dynamicValue || [];
        if (isSelected && !currentValues.includes(variableName)) {
          return { ...event, dynamicValue: [...currentValues, variableName] };
        } else if (!isSelected && currentValues.includes(variableName)) {
          return { ...event, dynamicValue: currentValues.filter(val => val !== variableName) };
        }
      }
      return event;
    }));
  };

  const getCharacterCount = (text, limit) => {
    const count = text.length;
    const isOverLimit = count > limit;
    return (
      <Text fontSize="xs" color={isOverLimit ? 'red.500' : 'gray.500'}>
        {count}/{limit} characters {isOverLimit && '(limit exceeded)'}
      </Text>
    );
  };

  const handleSaveTemplate = async () => {
    // Validation
    if (!templateName.trim()) {
      toast({
        title: "Validation Error",
        description: "Template name is required",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (!templateType) {
      toast({
        title: "Validation Error",
        description: "Template type is required",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    if (selectedChannels.length === 0) {
      toast({
        title: "Validation Error",
        description: "Please select at least one channel",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // Validate variables have sample values
    if (allChannelVariables.length > 0) {
      const missingDescriptions = allChannelVariables.some(
        varName => !variableSampleValues[varName] || !variableSampleValues[varName].trim()
      );
      if (missingDescriptions) {
        toast({
          title: "Validation Error",
          description: "Please provide sample values for all variables",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }
    }

    // Validate events - ALL fields required if event is added
    if (events.length > 0) {
      for (let i = 0; i < events.length; i++) {
        const event = events[i];

        // Event name is required
        if (!event.eventName || !event.eventName.trim()) {
          toast({
            title: "Event Validation Error",
            description: `Event ${i + 1}: Event name is required`,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          return;
        }

        // Either fixed value or dynamic values must be provided
        const hasFixedValue = event.fixedValue && event.fixedValue.trim() !== "";
        const hasDynamicValues = event.dynamicValue && event.dynamicValue.length > 0;

        if (!hasFixedValue && !hasDynamicValues) {
          toast({
            title: "Event Validation Error",
            description: `Event ${i + 1}: Either fixed value or at least one dynamic value is required`,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          return;
        }
      }
    }

    // Validate WhatsApp specific fields
    if (selectedChannels.includes('Whatsapp')) {
      // Body is always required
      if ((!whatsappBody || !whatsappBody.trim()) && templateType !== '1') {
        toast({
          title: "WhatsApp Validation",
          description: "WhatsApp message body is required",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(0);
        return;
      }

      // Header validation
      if (whatsappHeader.type === 'text' && templateType !== '1') {
        if ((!whatsappHeader.content || !whatsappHeader.content.trim()) && templateType !== '1') {
          toast({
            title: "WhatsApp Validation",
            description: "Header text is required when header type is text",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setTabIndex(0);
          return;
        }
      }

      if ((whatsappHeader.type === 'image' && !whatsappHeader.file) && templateType !== '1') {
        toast({
          title: "WhatsApp Validation",
          description: "Image is required when header type is image",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(0);
        return;
      }

      if ((whatsappHeader.type === 'video' && !whatsappHeader.file) && templateType !== '1') {
        toast({
          title: "WhatsApp Validation",
          description: "Video is required when header type is video",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(0);
        return;
      }

      if ((whatsappHeader.type === 'document' && !whatsappHeader.document_filename?.trim()) && templateType !== '1') {
        toast({
          title: "WhatsApp Validation",
          description: "Document filename is required when header type is document",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(0);
        return;
      }

      if ((whatsappHeader.type === 'document' && !whatsappHeader.file) && templateType !== '1') {
        toast({
          title: "WhatsApp Validation",
          description: "Document is required when header type is document",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(0);
        return;
      }

      // Validate buttons
      for (let i = 0; i < whatsappButtons.length; i++) {
        const button = whatsappButtons[i];

        if ((!button.name || !button.name.trim()) && templateType !== '1') {
          toast({
            title: "WhatsApp Button Validation",
            description: `Button ${i + 1}: Button text is required`,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setTabIndex(0);
          return;
        }

        if (!button.type && templateType !== '1') {
          toast({
            title: "WhatsApp Button Validation",
            description: `Button ${i + 1}: Button type is required`,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setTabIndex(0);
          return;
        }

        if (button.type === 'call-me' && (!button.phoneNumber || !button.phoneNumber.trim()) && templateType !== '1') {
          toast({
            title: "WhatsApp Button Validation",
            description: `Button ${i + 1}: Phone number is required`,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setTabIndex(0);
          return;
        }

        if (button.type === 'custom-link' && (!button.url || !button.url.trim()) && templateType !== '1') {
          toast({
            title: "WhatsApp Button Validation",
            description: `Button ${i + 1}: URL is required`,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setTabIndex(0);
          return;
        }
      }
    }

    // Validate In-App specific fields
    if (selectedChannels.includes('In-App Notification')) {
      // Body is always required
      if (!inAppBody || !inAppBody.trim()) {
        toast({
          title: "In-App Validation",
          description: "In-App message body is required",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(3);
        return;
      }

      // Header validation
      if (inAppHeader.type === 'text' && templateType !== '1') {
        if (!inAppHeader.content || !inAppHeader.content.trim()) {
          toast({
            title: "In-App Validation",
            description: "Header text is required when header type is text",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setTabIndex(3);
          return;
        }
      }

      if ((inAppHeader.type === 'image' && !inAppHeader.file) && templateType !== '1') {
        toast({
          title: "In-App Validation",
          description: "Image is required when header type is image",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(3);
        return;
      }

      if ((inAppHeader.type === 'video' && !inAppHeader.file) && templateType !== '1') {
        toast({
          title: "In-App Validation",
          description: "Video is required when header type is video",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(3);
        return;
      }

      if ((inAppHeader.type === 'document' && !inAppHeader.file) && templateType !== '1') {
        toast({
          title: "In-App Validation",
          description: "Document is required when header type is document",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(3);
        return;
      }

      // Validate buttons
      for (let i = 0; i < inAppButtons.length; i++) {
        const button = inAppButtons[i];

        if ((!button.name || !button.name.trim()) && templateType !== '1') {
          toast({
            title: "In-App Button Validation",
            description: `Button ${i + 1}: Button text is required`,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setTabIndex(3);
          return;
        }

        if (!button.type && templateType !== '1') {
          toast({
            title: "In-App Button Validation",
            description: `Button ${i + 1}: Button type is required`,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setTabIndex(3);
          return;
        }

        if (button.type === 'call-me' && (!button.phoneNumber || !button.phoneNumber.trim()) && templateType !== '1') {
          toast({
            title: "In-App Button Validation",
            description: `Button ${i + 1}: Phone number is required`,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setTabIndex(3);
          return;
        }

        if (button.type === 'custom-link' && (!button.url || !button.url.trim()) && templateType !== '1') {
          toast({
            title: "In-App Button Validation",
            description: `Button ${i + 1}: URL is required`,
            status: "error",
            duration: 3000,
            isClosable: true,
          });
          setTabIndex(3);
          return;
        }
      }
    }

    // Validate SMS specific fields
    if (selectedChannels.includes('SMS')) {
      if (!smsBody || !smsBody.trim()) {
        toast({
          title: "SMS Validation",
          description: "SMS message is required",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(1);
        return;
      }
    }

    // Validate Push Notification specific fields
    if (selectedChannels.includes('Push Notification')) {
      if (!pushTitle || !pushTitle.trim()) {
        toast({
          title: "Push Notification Validation",
          description: "Notification title is required",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(2);
        return;
      }

      if (!pushBody || !pushBody.trim()) {
        toast({
          title: "Push Notification Validation",
          description: "Notification body is required",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(2);
        return;
      }
    }

    // Validate Voice specific fields
    if (selectedChannels.includes('Voice (IVR)')) {
      if (voiceCallType === 'text_to_voice' && (!voiceScript || !voiceScript.trim())) {
        toast({
          title: "Voice Validation",
          description: "Voice script is required",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(4);
        return;
      }
      if (voiceCallType === 'recorded_call' && (!voiceCallId || !voiceCallId.trim())) {
        toast({
          title: "Voice Validation",
          description: "Call ID is required for recorded call",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(4);
        return;
      }
    }

    // Validate Email specific fields
    if (selectedChannels.includes('E-Mail')) {
      if (!emailSubject || !emailSubject.trim()) {
        toast({
          title: "Email Validation",
          description: "Email subject is required",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(5);
        return;
      }

      if (!emailHtml || !emailHtml.trim()) {
        toast({
          title: "Email Validation",
          description: "Email content is required",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        setTabIndex(5);
        return;
      }
    }

    setSaving(true);

    try {
      // Convert events to API format
      const eventsForAPI = events.map(event => ({
        [event.eventName]: {
          fixed_value: event.fixedValue || '',
          dynamic_value: event.dynamicValue || []
        }
      }));

      // Prepare the payload matching the logged structure
      const templateData = {
        // Basic Information
        templateName,
        templateType,
        description,
        customer_id: selectedCustomer || JSON.parse(localStorage.getItem("customer"))?.customer_id,

        // Master Message Content
        masterMessageContent: whatsappBody, // or use a separate masterMessageContent state

        // Variables
        variables: variables.map(v => ({
          name: v.name,
          description: v.description
        })),

        // Channels
        selectedChannels,
        selectedChannelIds: selectedChannels.map(channelName => {
          const channel = availableChannels.find(ch => ch.name === channelName);
          return channel?.id;
        }).filter(Boolean),

        // WhatsApp Configuration
        whatsappBody,
        whatsappHeader: {
          type: whatsappHeader.type,
          content: whatsappHeader.content,
          fileUrl: whatsappHeader.file || '',
          document_filename: whatsappHeader.document_filename || '',
          mediaType: whatsappHeader.type,
          headerText: whatsappHeader.content,
          footerText: whatsappFooter,
          ...(whatsappHeader.type === 'location' && {
            location_name: whatsappHeader.location_name || '',
            location_address: whatsappHeader.location_address || '',
            latitude: whatsappHeader.latitude || '',
            longitude: whatsappHeader.longitude || ''
          })
        },
        whatsappFooter,
        whatsappButtons: whatsappButtons.map(btn => ({
          id: btn.id,
          type: btn.type,
          name: btn.name,
          countryCode: btn.countryCode,
          phoneNumber: btn.phoneNumber,
          url: btn.url,
          urlType: btn.urlType
        })),
        whatsappTemplateName: templateName,
        isExpiryEnabled: whatsappMessageExpiryEnabled,
        expiry_time: whatsappMessageExpiryEnabled ? parseInt(whatsappMessageExpiry) : 0,

        // In-App Configuration
        inAppBody,
        inAppHeader: {
          type: inAppHeader.type,
          content: inAppHeader.content,
          fileUrl: inAppHeader.file || '',
          mediaType: inAppHeader.type,
          headerText: inAppHeader.content,
          footerText: inAppFooter,
        },
        inAppFooter,
        inAppButtons: inAppButtons.map(btn => ({
          id: btn.id,
          type: btn.type,
          name: btn.name,
          countryCode: btn.countryCode,
          phoneNumber: btn.phoneNumber,
          url: btn.url,
          urlType: btn.urlType
        })),
        inAppMessageExpiry: inAppMessageExpiryEnabled ? parseInt(inAppMessageExpiry) : 0,

        // SMS Configuration
        smsBody,

        // Push Notification Configuration
        pushTitle,
        pushBody,
        pushImage: pushImage ? { url: pushImage } : {},
        deep_link: deeplink, // Add if you have this field

        // Email Configuration
        emailSubject,
        emailType,
        emailHtml,
        emailTemplate,

        // Voice Configuration
        voiceScript: voiceCallType === 'text_to_voice' ? voiceScript : '',
        voiceRetries: voiceRetries || '',
        voiceCallType,
        voiceCallId: voiceCallType === 'recorded_call' ? voiceCallId : '',
        voiceVariableSource: voiceCallType === 'recorded_call' ? voiceVariableSource : '',
        ivr_variables: voiceCallType === 'recorded_call' && voiceVariableSource === 'custom'
          ? ivrVariables.filter((v) => v.trim())
          : allChannelVariables,

        // OTP Configuration (if template type is OTP)
        ...(templateType === '1' && {
          otpType,
          otpApps: otpApps.filter(app => app.package_name && app.signature_hash),
          authAddSecurityRecommendation,
          authAddExpirationTime
        }),

        // Events
        events: eventsForAPI,

        // Language
        lang: lang || 'en',
        authCodeExpiryMinutes: authCodeExpiryMinutes
      };



      const url = isEdit
        ? `${process.env.REACT_APP_API_URL}/template-message/update-combine`
        : `${process.env.REACT_APP_API_URL}/template-message/create-combine`;

      const payload = isEdit ? { id, ...templateData } : templateData;
      // console.log(payload)
      const response = await axios.post(url, payload, {

        headers: {
          "Content-Type": "application/json",
          "x-access-token": localStorage.getItem("user"),
          // "x-api-key": localStorage.getItem("api-key"),
        },

      });

      if (response.data?.success) {

        toast({
          title: `Template ${isEdit ? "updated" : "created"} successfully`,
          description: response.data.message || `Template ${isEdit ? "updated" : "created"} successfully`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        navigate(-1)

      } else {
        toast.error(response.data?.message || "Failed to save template");
      }

    } catch (error) {
      console.error("Save error:", error);
      // toast.error(error.response?.data?.error || error.response?.data?.message || "Failed to save template");
    } finally {
      setSaving(false);
    }
  };

  const renderButtonConfiguration = (buttons, updateButton, removeButton, maxButtons, buttonLabel) => {
    if (buttons.length === 0) {
      return (
        <Box textAlign="center" py={8} color="gray.500">
          <Text>No buttons added yet. Click "Add Button" to create interactive buttons.</Text>
        </Box>
      );
    }

    const countryCodeOptions = COUNTRY_CODES.map(c => ({
      value: c.iso,           // unique key (e.g. 'US', 'CA', 'IN')
      label: `${c.name} (${c.code})`,
      iso: c.iso,
      name: c.name,
      code: c.code,           // dial code (e.g. '+1', '+91')
    }));

    return (
      <VStack spacing={4}>
        {buttons.map((button, index) => (
          <Card key={button.id} w="full" bg="white" borderWidth="1px" borderColor="gray.200">
            <CardBody>
              <VStack spacing={4} align="stretch">
                <Flex justify="space-between" align="center">
                  <Text fontSize="sm" fontWeight="medium">{buttonLabel} {index + 1}</Text>
                  <IconButton
                    aria-label="Remove button"
                    icon={<LuTrash2 />}
                    size="sm"
                    colorScheme="red"
                    variant="ghost"
                    onClick={() => removeButton(button.id)}
                  />
                </Flex>

                <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }} gap={4}>
                  <FormControl>
                    <FormLabel fontSize="sm">Button Text</FormLabel>
                    <Input
                      value={button.name}
                      onChange={(e) => updateButton(button.id, { name: e.target.value })}
                      placeholder="Enter button text"
                      maxLength={20}
                      size="sm"
                    />
                    <Flex justify="flex-end" mt={1}>
                      {getCharacterCount(button.name, 20)}
                    </Flex>
                  </FormControl>

                  <FormControl>
                    <FormLabel fontSize="sm">Button Type</FormLabel>
                    <Select
                      value={button.type}
                      onChange={(e) => updateButton(button.id, { type: e.target.value })}
                      size="sm"
                    >
                      <option value="quick-reply">Quick Reply</option>
                      <option value="custom-link">Custom Link</option>
                      <option value="call-me">Call Me</option>
                    </Select>
                  </FormControl>
                </Grid>

                {button.type === 'custom-link' && (
                  <VStack spacing={4} align="stretch">
                    <Box>
                      <FormLabel fontSize="sm" display="flex" alignItems="center" gap={2}>
                        <LuGlobe />
                        URL Type
                      </FormLabel>
                      <VStack spacing={2} align="stretch">
                        <HStack spacing={2}>
                          <input
                            type="radio"
                            id={`static-${button.id}`}
                            name={`url-type-${button.id}`}
                            value="static"
                            checked={button.urlType === 'static'}
                            onChange={() => updateButton(button.id, { urlType: 'static' })}
                          />
                          <FormLabel htmlFor={`static-${button.id}`} mb={0} fontSize="sm" display="flex" alignItems="center" gap={2}>
                            <LuMonitor />
                            Static URL
                          </FormLabel>
                        </HStack>
                        <HStack spacing={2}>
                          <input
                            type="radio"
                            id={`dynamic-${button.id}`}
                            name={`url-type-${button.id}`}
                            value="dynamic"
                            checked={button.urlType === 'dynamic'}
                            onChange={() => updateButton(button.id, { urlType: 'dynamic' })}
                          />
                          <FormLabel htmlFor={`dynamic-${button.id}`} mb={0} fontSize="sm" display="flex" alignItems="center" gap={2}>
                            <LuZap />
                            Dynamic URL (with variables)
                          </FormLabel>
                        </HStack>
                      </VStack>
                    </Box>

                    <FormControl>
                      <FormLabel fontSize="sm">
                        {button.urlType === 'dynamic' ? 'URL Template' : 'URL'}
                      </FormLabel>
                      <Input
                        value={button.url || ''}
                        onChange={(e) => updateButton(button.id, { url: e.target.value })}
                        placeholder={
                          button.urlType === 'dynamic'
                            ? "e.g., https://example.com/verify?code={{1}}&user={{2}}"
                            : "e.g., https://example.com/verify"
                        }
                        size="sm"
                      />
                      {button.urlType === 'dynamic' && (
                        <Text fontSize="xs" color="gray.600" mt={1}>
                          Use {"{{"}1{"}}"}{"{{"}2{"}}"}  to wrap variable positions
                        </Text>
                      )}
                    </FormControl>
                  </VStack>
                )}

                {button.type === 'call-me' && (
                  <Grid templateColumns={{ base: '1fr', md: '250px 1fr' }} gap={4}>
                    <FormControl>
                      <FormLabel fontSize="sm">Country Code</FormLabel>
                      <ReactSelect
                        options={countryCodeOptions}
                        value={
                          // Match by ISO first (new format), fallback to dial code (old data)
                          countryCodeOptions.find(opt => opt.value === button.countryCodeIso) ||
                          countryCodeOptions.find(opt => opt.code === button.countryCode) ||
                          null
                        }
                        onChange={(selected) => {
                          if (selected) {
                            updateButton(button.id, {
                              countryCode: selected.code,      // dial code for API payload (e.g. '+91')
                              countryCodeIso: selected.value,   // ISO for unique selection (e.g. 'IN')
                            });
                          }
                        }}
                        placeholder="Search country..."
                        isSearchable
                        filterOption={(option, inputValue) => {
                          const q = inputValue.toLowerCase();
                          return (
                            option.data.name.toLowerCase().includes(q) ||
                            option.data.code.includes(q) ||
                            option.data.iso.toLowerCase().includes(q)
                          );
                        }}
                        formatOptionLabel={(option, { context }) => {
                          // Compact display when selected
                          if (context === 'value') {
                            return (
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px' }}>
                                <span style={{ color: '#718096' }}>{option.iso}</span>
                                <span>{option.code}</span>
                              </div>
                            );
                          }
                          // Full display in dropdown
                          return (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px' }}>
                              <span style={{ color: '#718096', minWidth: '28px' }}>{option.iso}</span>
                              <span>{option.name}</span>
                              <span style={{ color: '#A0AEC0', marginLeft: 'auto', fontFamily: 'monospace' }}>{option.code}</span>
                            </div>
                          );
                        }}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: '32px',
                            fontSize: '14px',
                            borderColor: '#E2E8F0',
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            padding: '0 8px',
                          }),
                          input: (base) => ({
                            ...base,
                            margin: 0,
                            padding: 0,
                          }),
                          indicatorSeparator: () => ({ display: 'none' }),
                          dropdownIndicator: (base) => ({
                            ...base,
                            padding: '4px',
                          }),
                          option: (base, state) => ({
                            ...base,
                            fontSize: '13px',
                            padding: '6px 12px',
                            backgroundColor: state.isSelected ? '#EBF8FF' : state.isFocused ? '#F7FAFC' : 'white',
                            color: '#1A202C',
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          menuList: (base) => ({
                            ...base,
                            maxHeight: '200px',
                          }),
                          singleValue: (base) => ({
                            ...base,
                            fontSize: '13px',
                          }),
                        }}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                      />
                    </FormControl>

                    <FormControl>
                      <FormLabel fontSize="sm">Phone Number</FormLabel>
                      <Input
                        value={button.phoneNumber || ''}
                        onChange={(e) => updateButton(button.id, { phoneNumber: e.target.value })}
                        placeholder="Enter phone number without country code"
                        size="sm"
                      />
                    </FormControl>
                  </Grid>
                )}
              </VStack>
            </CardBody>
          </Card>
        ))}
      </VStack>
    );
  };
  const isTemplateApproved = (whatsappStatusId === 1 && (templateDataGlobal.message_type_id === templateDataGlobal?.wa_message_type_id));
 const handleCustomerChange = (option) => {
        setSelectedCustomer(option?.value || "");

        const customerChannels = getCustomerChannels(option?.value);
        setAvailableChannels(customerChannels);
        filterSelectedChannelsByAvailability(customerChannels);
    };

  return (
    <>
      <Header />

      <BoxWrapper >
        <VStack spacing={6} align="stretch">
          {/* Header */}
          <Flex justify="space-between" align="center">
            <Box>
              <Heading size={"lg"} >{isEdit ? "Edit Template" : "Create New Template"}</Heading>
              <Text color="gray.600">Configure multi-channel message template</Text>
            </Box>
            <Button leftIcon={<LuSave />} size={"sm"} bg="#2563eb" colorScheme="blue" onClick={handleSaveTemplate} disabled={saving} isLoading={saving}>
              {isEdit ? "Update Template" : "Save Template"}
            </Button>
          </Flex>

          {/* Basic Information */}
          <Box bg="white" className='box-style-card' >
            <Box>
              <Text fontSize={"lg"} fontWeight={"600"}>Basic Information</Text>
            </Box>
            <Box>
              <VStack spacing={4} align="stretch">
                <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={4}>
                  <FormControl isRequired>
                    <FormLabel>Template Name</FormLabel>
                    <Input
                      value={templateName}
                      onChange={(e) => setTemplateName(e.target.value)}
                      placeholder="Enter template name"

                    />
                  </FormControl>

                  <FormControl isRequired>
                    <FormLabel>Template Type</FormLabel>
                    <Select
                      value={templateType}
                      onChange={(e) => {
                        setTemplateType(e.target.value);
                        setOtpType('');
                      }}
                      placeholder="Select template type"
                      disabled={isEdit}
                    >
                      {templateTypes.map((type) => (
                        <option key={type.id} value={type.id}>
                          {type.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl isRequired>
                    <FormLabel>Customer</FormLabel>
                    <ReactSelect
                      options={customerList?.map(c => ({
                        value: c.id,
                        label: c.business_name
                      }))}
                      value={customerList.find(c => c.id === selectedCustomer)
                        ? {
                          value: selectedCustomer,
                          label: customerList.find(c => c.id === selectedCustomer)?.business_name || customerList.find(c => c.id === selectedCustomer)?.name
                        }
                        : null}
                      onChange={(option) => handleCustomerChange(option)}
                      placeholder="Select Customer..."
                      isDisabled={isEdit}
                    />
                  </FormControl>

                  <FormControl>
                    <FormLabel>Language</FormLabel>
                    <ReactSelect
                      options={languageOptions}
                      value={languageOptions.find(opt => opt.value === lang) || null}
                      onChange={(selected) => setLang(selected?.value || 'en')}
                      placeholder="Search language..."
                      isSearchable
                      isDisabled={isEdit}
                      filterOption={(option, inputValue) => {
                        const q = inputValue.toLowerCase();
                        return (
                          option.data.label.toLowerCase().includes(q) ||
                          option.data.value.toLowerCase().includes(q)
                        );
                      }}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: '40px',
                          borderColor: '#E2E8F0',
                        }),
                        indicatorSeparator: () => ({ display: 'none' }),
                        option: (base, state) => ({
                          ...base,
                          fontSize: '14px',
                          backgroundColor: state.isSelected ? '#EBF8FF' : state.isFocused ? '#F7FAFC' : 'white',
                          color: '#1A202C',
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                        menuList: (base) => ({
                          ...base,
                          maxHeight: '200px',
                        }),
                      }}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </FormControl>
                </Grid>


                <FormControl>
                  <FormLabel>Description (Optional)</FormLabel>
                  <Textarea
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Brief description of this template"
                    rows={2}
                  />
                </FormControl>
              </VStack>
            </Box>
          </Box>

          {/* Channel Configuration using ChannelTabsFixed */}
          <ChannelTabsFixed
            selectedChannels={selectedChannels}
            setLang={setLang}
            lang={lang}
            setPushDeepLink={setPushDeepLink}
            deeplink={deeplink}
            setAuthCodeExpiryMinutes={setAuthCodeExpiryMinutes}
            authCodeExpiryMinutes={authCodeExpiryMinutes}
            availableChannels={availableChannels}
            setTabIndex={setTabIndex}
            tabIndex={tabIndex}
            isTemplateApproved={isTemplateApproved}
            // selectedChannels={selectedChannels}
            handleChannelToggle={handleChannelToggle}
            whatsappBody={whatsappBody}
            setWhatsappBody={setWhatsappBody}
            whatsappMessageExpiry={whatsappMessageExpiry}
            setWhatsappMessageExpiry={setWhatsappMessageExpiry}
            whatsappMessageExpiryEnabled={whatsappMessageExpiryEnabled}
            setWhatsappMessageExpiryEnabled={setWhatsappMessageExpiryEnabled}
            whatsappHeader={whatsappHeader}
            setWhatsappHeader={setWhatsappHeader}
            whatsappFooter={whatsappFooter}
            setWhatsappFooter={setWhatsappFooter}
            whatsappButtons={whatsappButtons}
            addWhatsAppButton={addWhatsAppButton}
            updateWhatsAppButton={updateWhatsAppButton}
            removeWhatsAppButton={removeWhatsAppButton}
            handleWhatsAppHeaderTypeChange={handleWhatsAppHeaderTypeChange}
            handleFileUpload={handleFileUpload}
            removeImage={removeImage}
            uploading={uploading}
            pushImage={pushImage}
            templateType={templateType}
            otpType={otpType}
            setOtpType={setOtpType}
            otpApps={otpApps}
            addOtpApp={addOtpApp}
            updateOtpApp={updateOtpApp}
            removeOtpApp={removeOtpApp}
            inAppBody={inAppBody}
            setInAppBody={setInAppBody}
            inAppMessageExpiry={inAppMessageExpiry}
            setInAppMessageExpiry={setInAppMessageExpiry}
            inAppMessageExpiryEnabled={inAppMessageExpiryEnabled}
            setInAppMessageExpiryEnabled={setInAppMessageExpiryEnabled}
            inAppHeader={inAppHeader}
            setInAppHeader={setInAppHeader}
            inAppFooter={inAppFooter}
            setInAppFooter={setInAppFooter}
            inAppButtons={inAppButtons}
            addInAppButton={addInAppButton}
            updateInAppButton={updateInAppButton}
            removeInAppButton={removeInAppButton}
            handleInAppHeaderTypeChange={handleInAppHeaderTypeChange}
            smsBody={smsBody}
            setSmsBody={setSmsBody}
            pushTitle={pushTitle}
            setPushTitle={setPushTitle}
            pushBody={pushBody}
            setPushBody={setPushBody}
            setPushImage={setPushImage}
            emailSubject={emailSubject}
            setEmailSubject={setEmailSubject}
            emailType={emailType}
            setEmailType={setEmailType}
            emailHtml={emailHtml}
            setEmailHtml={setEmailHtml}
            emailTemplate={emailTemplate}
            setEmailTemplate={setEmailTemplate}
            voiceScript={voiceScript}
            setVoiceScript={setVoiceScript}
            voiceRetries={voiceRetries}
            setVoiceRetries={setVoiceRetries}
            voiceCallType={voiceCallType}
            setVoiceCallType={setVoiceCallType}
            voiceCallId={voiceCallId}
            setVoiceCallId={setVoiceCallId}
            voiceVariableSource={voiceVariableSource}
            setVoiceVariableSource={setVoiceVariableSource}
            ivrVariables={ivrVariables}
            setIvrVariables={setIvrVariables}
            allChannelVariables={allChannelVariables}
            getCharacterCount={getCharacterCount}
            renderButtonConfiguration={renderButtonConfiguration}
            // messageExpiryOptions={messageExpiryOptions}
            syncWhatsAppToInApp={syncWhatsAppToInApp}
            syncInAppToWhatsApp={syncInAppToWhatsApp}
            setAuthAddSecurityRecommendation={setAuthAddSecurityRecommendation}
            setAuthAddExpirationTime={setAuthAddExpirationTime}
            authAddExpirationTime={authAddExpirationTime}
            authAddSecurityRecommendation={authAddSecurityRecommendation}
          />

          {/* Variables Section */}
          {selectedChannels.length > 0 && allChannelVariables.length > 0 && (
            <Box className='box-style-card'>
              <Box>
                <HStack spacing={2}>
                  <LuDollarSign size={20} color="orange" />
                  <Text fontSize={"lg"} fontWeight={"600"}>Variables</Text>
                </HStack>
                <Text fontSize="sm" color="gray.600" mt={2}>
                  Variables detected across all enabled channels
                </Text>
                {hasInconsistentVariables && (
                  <Alert bg={"trasparent"} border={"1px solid #0000001a"} mt={3} borderRadius={"8.45px"}>
                    <AlertIcon color={"#64748b"} />
                    <AlertDescription fontSize="sm" color="#64748b">
                      Some variables are missing in certain channels
                    </AlertDescription>
                  </Alert>
                )}
              </Box>
              <Box>
                <VStack spacing={3} align="stretch">
                  {allChannelVariables.map((variableName) => {
                    const usage = getVariableChannelUsage(variableName);
                    const usageForConsistency = getVariableChannelUsageForConsistency(variableName);

                    const missingInSomeChannels = usageForConsistency.some(u => !u.present);

                    return (
                      <Box
                        key={variableName}
                        p={4}
                        mt={4}
                        borderWidth="1px"
                        borderRadius={"8.45px"}
                        borderColor={missingInSomeChannels ? 'orange.300' : 'gray.200'}
                        bg={missingInSomeChannels ? '#fff7ed' : 'transparent'}
                      >
                        <Grid templateColumns={{ base: '1fr', lg: '200px 1fr' }} gap={4}>
                          <Box>
                            <Text fontSize="sm" fontWeight="medium" mb={2}>Variable</Text>
                            <HStack spacing={2} mb={2}>
                              <Tag bg="transparent" borderWidth="1px" borderColor="#0000001a" fontSize="xs">
                                ${variableName}
                              </Tag>

                              {missingInSomeChannels && (
                                <Tag bg="#dc2626" fontSize="xs" color="white">
                                  Inconsistent
                                </Tag>
                              )}
                            </HStack>

                            <Flex flexWrap="wrap" gap={1} mt={2}>

                              {usage.map((channelUsage) => {
                                const isPushBody = channelUsage.channel === 'Push' &&
                                  !pushTitle.includes(`$${variableName}`) &&
                                  pushBody.includes(`$${variableName}`);
                                const showAsInconsistent = !channelUsage.present && !isPushBody;

                                return (
                                  <Tag
                                    key={channelUsage.channel}
                                    bg={
                                      channelUsage.present
                                        ? channelUsage.channel === 'WhatsApp' ? 'green' :
                                          channelUsage.channel === 'SMS' ? 'blue' :
                                            channelUsage.channel === 'Email' ? 'red' :
                                              channelUsage.channel === 'Push' ? 'orange' :
                                                channelUsage.channel === 'In-App' ? 'cyan' :
                                                  channelUsage.channel === 'Voice' ? 'purple' : 'gray'
                                        : showAsInconsistent ? 'transparent' : 'black'
                                    }
                                    borderColor={
                                      channelUsage.present
                                        ? channelUsage.channel === 'WhatsApp' ? 'green' :
                                          channelUsage.channel === 'SMS' ? 'blue' :
                                            channelUsage.channel === 'Email' ? 'red' :
                                              channelUsage.channel === 'Push' ? 'orange' :
                                                channelUsage.channel === 'In-App' ? 'cyan' :
                                                  channelUsage.channel === 'Voice' ? 'purple' : 'gray'
                                        : 'red'
                                    }

                                    variant={channelUsage.present ? 'solid' : 'outline'}
                                    fontSize="2xs"
                                  >
                                    {channelUsage.channel}
                                    {showAsInconsistent && ' ✗'}
                                  </Tag>
                                );
                              })}
                            </Flex>
                          </Box>

                          <FormControl>
                            <FormLabel fontSize="sm">Sample Value</FormLabel>
                            <Input
                              value={variableSampleValues[variableName] || ''}
                              onChange={(e) => updateVariableSampleValue(variableName, e.target.value)}
                              placeholder={`Enter sample value for $${variableName}...`}
                              size="sm"
                              bg={"white"}
                            />
                          </FormControl>
                        </Grid>
                      </Box>
                    );
                  })}
                </VStack>
              </Box>
            </Box>
          )}

          {/* Event Capturing */}
          <Box className='box-style-card'>
            <Box>
              <HStack spacing={2}>
                <LuActivity size={20} color="purple" />
                <Text fontSize={"lg"} fontWeight={"600"}>Event Capturing</Text>
              </HStack>
              <Text fontSize="sm" color="gray.600" mt={1}>
                Configure events to capture when this template is used
              </Text>
            </Box>
            <Box>
              <VStack spacing={4} align="stretch">
                <Flex justify="space-between" align="center">
                  <span></span>
                  {events.length === 0 && (
                    <Button
                      size="sm"
                      leftIcon={<LuPlus />}
                      onClick={addEvent}
                      variant="outline"
                    >
                      Add Event
                    </Button>
                  )}
                </Flex>

                {events.length === 0 ? (
                  <Box textAlign="center" py={8} color="gray.500">
                    <LuTarget size={32} style={{ margin: '0 auto 8px', opacity: 0.5 }} />
                    <Text>No events configured yet</Text>
                  </Box>
                ) : (
                  <VStack spacing={4}>
                    {events.map((event) => (
                      <Box
                        key={event.id}
                        p={4}
                        borderWidth="1px"
                        borderRadius="md"
                        w="full"
                        bg="white"
                      >
                        <VStack spacing={4} align="stretch">
                          <Flex justify="space-between">
                            <Text fontWeight="semibold">Events</Text>
                            <IconButton
                              aria-label="Remove event"
                              icon={<LuTrash2 />}
                              size="sm"
                              colorScheme="red"
                              variant="ghost"
                              onClick={() => removeEvent(event.id)}
                            />
                          </Flex>

                          <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={4}>
                            <FormControl isRequired>
                              <FormLabel fontSize="sm">Event Name</FormLabel>
                              <Input
                                value={event.eventName}
                                onChange={(e) => updateEvent(event.id, { eventName: e.target.value })}
                                placeholder="e.g., OTP_Sent"
                                size="sm"
                              />
                            </FormControl>

                            <FormControl>
                              <FormLabel fontSize="sm">Dynamic Values</FormLabel>
                              <Box
                                borderWidth="1px"
                                borderRadius="md"
                                p={2}
                                maxH="120px"
                                overflowY="auto"
                              >
                                {variables.length > 0 ? (
                                  <VStack spacing={2} align="stretch">
                                    {variables.map((variable, index) => (
                                      <Checkbox
                                        key={variable.name || index}
                                        isChecked={event.dynamicValue?.includes(variable.name) || false}
                                        onChange={(e) =>
                                          updateEventDynamicValue(event.id, variable.name, e.target.checked)
                                        }
                                        size="sm"
                                      >
                                        <Text fontSize="sm"  >
                                          ${variable.name}
                                        </Text>
                                      </Checkbox>
                                    ))}
                                  </VStack>
                                ) : (
                                  <Text fontSize="xs" color="gray.500">
                                    No variables available
                                  </Text>
                                )}
                              </Box>
                            </FormControl>

                            <FormControl>
                              <FormLabel fontSize="sm">Fixed Value</FormLabel>
                              <Input
                                value={event.fixedValue}
                                onChange={(e) => updateEvent(event.id, { fixedValue: e.target.value })}
                                placeholder="Enter fixed value"
                                size="sm"
                              />
                            </FormControl>
                          </Grid>

                          {event.dynamicValue && event.dynamicValue.length > 0 && (
                            <Box>
                              <Text fontSize="xs" color="gray.600" mb={1}>Selected Variables:</Text>
                              <Flex flexWrap="wrap" gap={1}>
                                {event.dynamicValue.map((varName) => (
                                  <Tag key={varName} border="1px solid #E2E8F0" fontSize="xs" bg="transparent">
                                    ${varName}
                                  </Tag>
                                ))}
                              </Flex>
                            </Box>
                          )}
                        </VStack>
                      </Box>
                    ))}
                  </VStack>
                )}
              </VStack>
            </Box>
          </Box>
        </VStack>
      </BoxWrapper>

    </>
  );
}